import { generatePath } from 'react-router-dom';
export function createAktenLink(opts) {
    return generatePath(ROUTE_AKTE, { aktenId: opts.id }); // TODO direct links to documents not yet supported
}
export const ROUTE_AKTE = ':aktenId';
